import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { clientService } from "../../../../../../api";
import { Button, Table, TopProgress, ModalVariables } from "../../../../../../components";
import { useUi } from "../../../../../../context/ui.context";
import { useAuth } from "../../../../../../context/user.context";
import { icons } from "../../../../../../icons";
import {
  PageContainer
} from '../styles'

const Users:FC = () => {
  const [t] = useTranslation()
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const [users, setUsers] = useState<any[]>([])
  const [selectedUserId, setSelectedUserId] = useState<any>(false)
  const [userToEdit, setUserToEdit] = useState()
  const [clientForInvite, setClientToInvite] = useState<any>()
  const {viewAlert} = useUi()
  const {userId} = useParams()
  const {
    setAvailableNotifications,
    setAvailableRoles,
  } = useAuth()
  const [paginationData, setPaginationData] = useState<any>()

  // Modal state
  const [viewModal, setViewModal] = useState<boolean>(false)
  const [activeAnimation, setActiveAnimation] = useState<boolean>(false)
  const [modalType, setModalType] = useState<any>('')
  const [alertTitle, setAlertTitle] = useState<string>('')
  const [alertSubTitle, setAlertSubTitle] = useState<string>('')

  const openModal = (type: string, options?: any) => {
    setModalType(type)
    setAlertTitle(options?.alertTitle || '')
    setAlertSubTitle(options?.alertSubTitle || '')
    setViewModal(true)
    setActiveAnimation(true)
  }

  const closeModalCancel = () => {
    setViewModal(false)
    setActiveAnimation(false)
  }

  const updateUsers = async () => {
    try{
      if(userId){
        const res = await clientService.getClientUsers(userId)
        setUsers([...res.data.users].map((user:any) => {
          return {
            ...user,
            name:user.email,
            navigate:`/clients-users/users/${user.id}`,
            _invitation:!user.invitation ? t("YES") : t("NO"),
            roles:user.roles.map((role:any) => role.display_name),
            id:`${user.id}`,
            invitation:user.invitation,
            _roles:user.roles,
            invitation_id:user.invitation_id,
          }
        }))
        setPageLoading(false)
      }
    } catch(e:any) {
      setPageLoading(false)
      if(e?.response?.data?.detail){
        viewAlert({
          severity:'error',
          message:e?.response?.data?.detail
        })
      }
    }
  }
  const closeModal = (props?:any) => {
    if(modalType === 'universal'){
      _dissociateUser(userToEdit)
    }
    setViewModal(false)
    setActiveAnimation(false)
    updateUsers()
  }
  const getDataForInvite = async () => {
    const roles:any = await clientService.getAvailableRoles(userId)
    setAvailableRoles(roles.data.roles)
  }

  const getData = async () => {
    try{
      if(userId) {
        const res = await clientService.getClient(userId)
        setClientToInvite(res.data)
        updateUsers()
      }
    } catch(e) {
      console.log('err get client', e);
    }
  }
  useEffect(() => {
   getData()
  },[])

  const _dissociateUser = (user:any) => {
    if(user?.notInvited) {
      clientService.deleteUserFromClientNotInvited(user.invitation_id)
      .then((res) => {
        if(res.data.detail === 'User dissociated'){
          viewAlert({
            severity:'info',
            message:res.data.detail
          })
        }
        updateUsers()
      })
      .catch((e) => {
        if(e?.response?.data?.detail){
          viewAlert({
            severity:'error',
            message:e?.response?.data?.detail
          })
        }
      })
    } else {
      const data = {
        id: userId,
        relation_id: user.invitation_id
      }
      clientService.dissociateUser(userId, data)
      .then((res) => {
        if(res.data.detail === 'User dissociated'){
          viewAlert({
            severity:'info',
            message:res.data.detail
          })
        }
        updateUsers()
      })
      .catch((e) => {
        if(e?.response?.data?.detail){
          viewAlert({
            severity:'error',
            message:e?.response?.data?.detail
          })
        }
      })
    }
  }
  const items = [
    {
      title:t("EDIT_ROLES"),
      id:'2',
      onClick:(item:any) => {
        setSelectedUserId(item)
        openModal('edit-roles',
          {
            closeModal,
            alertTitle:t("DISSOCIATE_USER"),
            alertSubTitle:t("DISSOCIATE_USER_ALERT"),
            id:selectedUserId
          }
        )
      },
      checkField:'invitation',
      icon:icons.Clients,
      divider:false
    },
    {
      title:t("EDIT_NOTIFICATION_SETTINGS"),
      id:'3',
      onClick:(item:any) => {
        setSelectedUserId(item)
        openModal('edit-notifications',
          {
            closeModal,
            alertTitle:t("DISSOCIATE_USER"),
            alertSubTitle:t("DISSOCIATE_USER_ALERT"),
            id:selectedUserId
          }
        )
      },
      checkField:'invitation',
      icon:icons.Notification,
      divider:false
    },
    {
      title:t("DISSOCIATE_USER"),
      id:'4',
      onClick:(item:any) => {
        setUserToEdit(item)
        openModal('universal',
          {
            closeModal,
            alertTitle:t("DISSOCIATE_USER"),
            alertSubTitle:t("DISSOCIATE_USER_ALERT"),
            id:selectedUserId
          }
        )
      },
      icon:icons.MinusDefault,
      divider:false
    },
  ]
  const limitedItems = [
    {
      title:t("DISSOCIATE_USER"),
      id:'6',
      icon:icons.MinusDefault,
      onClick:(item:any) => {
        setUserToEdit({...item, notInvited:true});
        openModal('universal',
          {
            closeModal,
            alertTitle:t("DISSOCIATE_USER"),
            alertSubTitle:t("DISSOCIATE_USER_ALERT"),
            id:selectedUserId
          }
        )
      },
      divider:false
    },
  ]
  const columns = [
    {
      title:t("EMAIL"),
      key:"name"
    },
    {
      title:t("ACCEPTED_INVITE"),
      key:"_invitation"
    },
    {
      title:t("ROLES"),
      key:"roles",
      withBackground:true,
    },
    {
      title:"",
      key:"props"
    }
  ]

  return(
    <PageContainer style={{display:'block'}}>
      <TopProgress loading={pageLoading}/>
      {pageLoading ? null :
        <>
          <div style={{display:'flex', gap:'10px', marginBottom:'10px'}}>
            <Button
              variant="primary"
              size="display"
              onClick={() => openModal('associate-user', {
                alertTitle: t("ASSOCIATE_USER"),
              })}
              title={t("ASSOCIATE_USER")}
            />
            <Button
              variant="stroke"
              size="display"
              onClick={() => openModal('invite-user', {
                alertTitle: t("INVITE_USER"),
                alertSubTitle: t("INVITE_USER_ALERT"),
              })}
              title={t("INVITE_USER")}
            />
          </div>
          <Table
            columns={columns}
            rows={users}
            settings={items}
            paginationData={paginationData}
            limitedItems={limitedItems}
            hideOther
          />
          <ModalVariables
            id={selectedUserId}
            modalType={modalType}
            closeModalCancel={closeModalCancel}
            viewModal={viewModal}
            activeAnimation={activeAnimation}
            closeModal={closeModal}
            alertTitle={alertTitle}
            alertSubTitle={alertSubTitle}
          />
        </>
      }
    </PageContainer>
  )
}

export default Users
